import { setSideNavFixed, setSideNavOpen, toggleSideNavFixed, toggleSideNavOpen } from "@/reducer/UIState";
import { useSideNavFixed, useSideNavOpen } from "@/reducer/selectors/UiSelectors";
import type React from "react";
import { createContext, useContext, useState } from "react";
import { useDispatch } from "react-redux";

interface SideNavContextType {
  open: boolean;
  setOpen: (v: boolean) => void;
  toggle: () => void;

  fixed: boolean;
  setFixed: (v: boolean) => void;
  toggleFixed: () => void;
}

const SideNavContext = createContext<SideNavContextType | null>(null);

export const SideNavProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch();
  const fixed = useSideNavFixed();
  const open = useSideNavOpen();

  return (
    <SideNavContext.Provider
      value={{
        open,
        setOpen: (v: boolean) => {
          dispatch(setSideNavOpen(v));
        },
        toggle: () => {
          dispatch(toggleSideNavOpen());
          dispatch(toggleSideNavFixed());
        },
        fixed,
        setFixed: (v: boolean) => dispatch(setSideNavFixed(v)),
        toggleFixed: () => dispatch(toggleSideNavFixed()),
      }}
    >
      {children}
    </SideNavContext.Provider>
  );
};

export const useSideNav = () => {
  const ctx = useContext(SideNavContext);
  if (!ctx) throw new Error("useSideNav must be used within SideNavProvider");
  return ctx;
};
